import { RatesService } from "../../services/RatesService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useRatesApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const ratesService = new RatesService(appConfig.apiBaseUrl);

    const findRatesByRoom = async (propertyId, roomId) => {
        return executeApiOperation(() => ratesService.findByRoom(propertyId, roomId));
    };

    const createRate = async (propertyId, roomId, planId, price) => {
        return executeApiOperation(() => ratesService.create(propertyId, roomId, planId, price));
    };

    const updateRate = async (propertyId, roomId, planId, price) => {
        return executeApiOperation(() => ratesService.update(propertyId, roomId, planId, price));
    };

    const updateAllRates = async (propertyId, roomId, rates) => {
        return executeApiOperation(() => ratesService.updateAll(propertyId, roomId, rates));
    };

    const deleteRate = async (propertyId, roomId, planId) => {
        return executeApiOperation(() => ratesService.delete(propertyId, roomId, planId));
    };

    return {
        findRatesByRoom,
        createRate,
        updateRate,
        updateAllRates,
        deleteRate,
    };
};
